/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as EsqueciSenhaRouteImport } from './routes/esqueci-senha'
import { Route as EntrarRouteImport } from './routes/entrar'
import { Route as CadastrarRouteImport } from './routes/cadastrar'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppConversasRouteImport } from './routes/_app.conversas'
import { Route as AppContatosRouteImport } from './routes/_app.contatos'
import { Route as AppAjustesRouteImport } from './routes/_app.ajustes'
import { Route as AppConversasIndexRouteImport } from './routes/_app.conversas.index'
import { Route as AppConversasConversationIdRouteImport } from './routes/_app.conversas.$conversationId'
import { Route as AppContatosContactIdRouteImport } from './routes/_app.contatos.$contactId'

const EsqueciSenhaRoute = EsqueciSenhaRouteImport.update({
  id: '/esqueci-senha',
  path: '/esqueci-senha',
  getParentRoute: () => rootRouteImport,
} as any)
const EntrarRoute = EntrarRouteImport.update({
  id: '/entrar',
  path: '/entrar',
  getParentRoute: () => rootRouteImport,
} as any)
const CadastrarRoute = CadastrarRouteImport.update({
  id: '/cadastrar',
  path: '/cadastrar',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppConversasRoute = AppConversasRouteImport.update({
  id: '/conversas',
  path: '/conversas',
  getParentRoute: () => AppRoute,
} as any)
const AppContatosRoute = AppContatosRouteImport.update({
  id: '/contatos',
  path: '/contatos',
  getParentRoute: () => AppRoute,
} as any)
const AppAjustesRoute = AppAjustesRouteImport.update({
  id: '/ajustes',
  path: '/ajustes',
  getParentRoute: () => AppRoute,
} as any)
const AppConversasIndexRoute = AppConversasIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppConversasRoute,
} as any)
const AppConversasConversationIdRoute =
  AppConversasConversationIdRouteImport.update({
    id: '/$conversationId',
    path: '/$conversationId',
    getParentRoute: () => AppConversasRoute,
  } as any)
const AppContatosContactIdRoute = AppContatosContactIdRouteImport.update({
  id: '/$contactId',
  path: '/$contactId',
  getParentRoute: () => AppContatosRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/cadastrar': typeof CadastrarRoute
  '/entrar': typeof EntrarRoute
  '/esqueci-senha': typeof EsqueciSenhaRoute
  '/ajustes': typeof AppAjustesRoute
  '/contatos': typeof AppContatosRouteWithChildren
  '/conversas': typeof AppConversasRouteWithChildren
  '/contatos/$contactId': typeof AppContatosContactIdRoute
  '/conversas/$conversationId': typeof AppConversasConversationIdRoute
  '/conversas/': typeof AppConversasIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/cadastrar': typeof CadastrarRoute
  '/entrar': typeof EntrarRoute
  '/esqueci-senha': typeof EsqueciSenhaRoute
  '/ajustes': typeof AppAjustesRoute
  '/contatos': typeof AppContatosRouteWithChildren
  '/contatos/$contactId': typeof AppContatosContactIdRoute
  '/conversas/$conversationId': typeof AppConversasConversationIdRoute
  '/conversas': typeof AppConversasIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/cadastrar': typeof CadastrarRoute
  '/entrar': typeof EntrarRoute
  '/esqueci-senha': typeof EsqueciSenhaRoute
  '/_app/ajustes': typeof AppAjustesRoute
  '/_app/contatos': typeof AppContatosRouteWithChildren
  '/_app/conversas': typeof AppConversasRouteWithChildren
  '/_app/contatos/$contactId': typeof AppContatosContactIdRoute
  '/_app/conversas/$conversationId': typeof AppConversasConversationIdRoute
  '/_app/conversas/': typeof AppConversasIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/cadastrar'
    | '/entrar'
    | '/esqueci-senha'
    | '/ajustes'
    | '/contatos'
    | '/conversas'
    | '/contatos/$contactId'
    | '/conversas/$conversationId'
    | '/conversas/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cadastrar'
    | '/entrar'
    | '/esqueci-senha'
    | '/ajustes'
    | '/contatos'
    | '/contatos/$contactId'
    | '/conversas/$conversationId'
    | '/conversas'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/cadastrar'
    | '/entrar'
    | '/esqueci-senha'
    | '/_app/ajustes'
    | '/_app/contatos'
    | '/_app/conversas'
    | '/_app/contatos/$contactId'
    | '/_app/conversas/$conversationId'
    | '/_app/conversas/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  CadastrarRoute: typeof CadastrarRoute
  EntrarRoute: typeof EntrarRoute
  EsqueciSenhaRoute: typeof EsqueciSenhaRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/esqueci-senha': {
      id: '/esqueci-senha'
      path: '/esqueci-senha'
      fullPath: '/esqueci-senha'
      preLoaderRoute: typeof EsqueciSenhaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entrar': {
      id: '/entrar'
      path: '/entrar'
      fullPath: '/entrar'
      preLoaderRoute: typeof EntrarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cadastrar': {
      id: '/cadastrar'
      path: '/cadastrar'
      fullPath: '/cadastrar'
      preLoaderRoute: typeof CadastrarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/conversas': {
      id: '/_app/conversas'
      path: '/conversas'
      fullPath: '/conversas'
      preLoaderRoute: typeof AppConversasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contatos': {
      id: '/_app/contatos'
      path: '/contatos'
      fullPath: '/contatos'
      preLoaderRoute: typeof AppContatosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ajustes': {
      id: '/_app/ajustes'
      path: '/ajustes'
      fullPath: '/ajustes'
      preLoaderRoute: typeof AppAjustesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/conversas/': {
      id: '/_app/conversas/'
      path: '/'
      fullPath: '/conversas/'
      preLoaderRoute: typeof AppConversasIndexRouteImport
      parentRoute: typeof AppConversasRoute
    }
    '/_app/conversas/$conversationId': {
      id: '/_app/conversas/$conversationId'
      path: '/$conversationId'
      fullPath: '/conversas/$conversationId'
      preLoaderRoute: typeof AppConversasConversationIdRouteImport
      parentRoute: typeof AppConversasRoute
    }
    '/_app/contatos/$contactId': {
      id: '/_app/contatos/$contactId'
      path: '/$contactId'
      fullPath: '/contatos/$contactId'
      preLoaderRoute: typeof AppContatosContactIdRouteImport
      parentRoute: typeof AppContatosRoute
    }
  }
}

interface AppContatosRouteChildren {
  AppContatosContactIdRoute: typeof AppContatosContactIdRoute
}

const AppContatosRouteChildren: AppContatosRouteChildren = {
  AppContatosContactIdRoute: AppContatosContactIdRoute,
}

const AppContatosRouteWithChildren = AppContatosRoute._addFileChildren(
  AppContatosRouteChildren,
)

interface AppConversasRouteChildren {
  AppConversasConversationIdRoute: typeof AppConversasConversationIdRoute
  AppConversasIndexRoute: typeof AppConversasIndexRoute
}

const AppConversasRouteChildren: AppConversasRouteChildren = {
  AppConversasConversationIdRoute: AppConversasConversationIdRoute,
  AppConversasIndexRoute: AppConversasIndexRoute,
}

const AppConversasRouteWithChildren = AppConversasRoute._addFileChildren(
  AppConversasRouteChildren,
)

interface AppRouteChildren {
  AppAjustesRoute: typeof AppAjustesRoute
  AppContatosRoute: typeof AppContatosRouteWithChildren
  AppConversasRoute: typeof AppConversasRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppAjustesRoute: AppAjustesRoute,
  AppContatosRoute: AppContatosRouteWithChildren,
  AppConversasRoute: AppConversasRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  CadastrarRoute: CadastrarRoute,
  EntrarRoute: EntrarRoute,
  EsqueciSenhaRoute: EsqueciSenhaRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
